<!-- 平水江水库 -->
<template>
  <div class="leftpic2 1">
    <div id="myChart" ref="myChart"></div>
    <div class="nowWaterLevel">当前水位：<b style="color:#3d6bfb">{{nowHourRiverLevel}}</b> m</div>
    <div class="leftMask"></div>
    <div class="waterLevelInfo">
      <p class="total-capacity">总库容:5457万m³</p>
      <p class="maximum-flood-discharge">最大泄洪流量:726m³/s</p>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import homepageTypes from '@/store/types/homepage'

// 导入echarts
let echarts = require('echarts/lib/echarts')

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
  // 这里存放数据
    return {
      nowHourRiverLevel: '',
      newNowHourRiverLevel: [],
      maxData: '51.10',
      designWaterLevel: '48.25',
      limitedWaterlLvel: '46.50',
      deadWaterLevel: '32.00',
      designWaterLevelLine: '',
      limitedWaterlLvelLine: '',
      deadWaterLevelLine: '',
      echartData: [],
      sID: '3',
      sTID: '214',
      beginDate: '2019-06-14 00:00',
      endDate: '2019-06-14 23:00',
      stationType: '2',
      finalLocal: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 获取水库水位
    getHourlyRiverLevelData () {
      this.$store.dispatch(homepageTypes.GET_HOURLY_RIVER_LEVEL, {
        sID: this.sID,
        sTID: this.sTID,
        beginDate: this.beginDate,
        endDate: this.endDate,
        stationType: this.stationType
      }).then(data => {
        let tableDate = data.rows[0].data
        console.log(tableDate)
        for (const i in tableDate) {
          this.echartData.push(tableDate[i].z)
        }
        var nowTime = new Date()
        var nowHour = nowTime.getHours() // 当前时间
        this.maxData = (this.maxData / 10).toFixed() * 10 + 5
        this.nowHourRiverLevel = this.echartData[nowHour - 1] // 当前水位
        // 重新赋值当前水位的所有数据为当前水位数据
        for (let i = 0; i < (this.echartData.length) / 2; i++) {
          this.newNowHourRiverLevel.push(this.nowHourRiverLevel)
          this.newNowHourRiverLevel.push(this.nowHourRiverLevel - 2)
        }
        this.drawCharts(this.newNowHourRiverLevel)
        console.log(this.nowHourRiverLevel)
        console.log(this.echartData)
      })
    },
    // 水库水位图表
    drawCharts (finalData) {
      // 计算设计洪水位位置 designWaterLevelLine
      this.designWaterLevelLine = 220 - (this.designWaterLevel / this.maxData * 220)
      // 计算汛限水位位置 limitedWaterlLvelLine
      this.limitedWaterlLvelLine = 220 - (this.limitedWaterlLvel / this.maxData * 220)
      // 计算死水位位置 deadWaterLevelLine
      this.deadWaterLevelLine = 220 - (this.deadWaterLevel / this.maxData * 220)
      let myChart = echarts.init(document.getElementById('myChart'))
      // 计算标志线的重点位置
      this.finalLocal = this.$refs.myChart.offsetWidth * 0.7
      console.log(this.finalLocal)
      myChart.setOption({
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          top: '5',
          left: '65',
          right: '0',
          bottom: '-10%',
          containLabel: true
        },
        xAxis: {
          show: false,
          type: 'category',
          boundaryGap: false,
          data: ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h']
        },
        yAxis: {
          show: false,
          type: 'value',
          max: this.maxData
        },
        series: [{
          name: '当前水位',
          smooth: true,
          symbolSize: 0,
          itemStyle: {
            normal: {
              borderWidth: 5,
              lineStyle: {
                width: 0
              }
            }
          },
          data: finalData,
          type: 'line',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'RGBA(45,168,205,1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'RGBA(45,168,205,.8)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
          markLine: {
            symbol: ['none', 'none'], // 去掉箭头
            label: {
              position: 'end',
              formatter: '{b}:  {c}'
            },
            data: [
              [
                { name: '设计洪水位', value: this.designWaterLevel + 'm', x: 0, y: this.designWaterLevelLine },
                { name: '设计洪水位终点', x: this.finalLocal, y: this.designWaterLevelLine },
                {
                  lineStyle: {
                    type: 'solid',
                    color: 'rgb(255,163,0)',
                    formatter: {
                      color: 'rgb(0,0,0)'
                    },
                    width: 2
                  }
                }
              ],
              [
                { name: '汛限水位', value: this.limitedWaterlLvel + 'm', x: 0, y: this.limitedWaterlLvelLine },
                { name: '汛限水位终点', x: this.finalLocal, y: this.limitedWaterlLvelLine },
                {
                  lineStyle: {
                    type: 'solid',
                    color: 'rgb(248,88,87)',
                    width: 2
                  }
                }
              ],
              [
                { name: '死水位', value: this.deadWaterLevel + 'm', x: 0, y: this.deadWaterLevelLine },
                { name: '死水位终点', x: this.finalLocal, y: this.deadWaterLevelLine },
                {
                  lineStyle: {
                    type: 'solid',
                    color: 'rgb(255,255,0)',
                    width: 2
                  }
                }
              ]
            ]
          }
        }]
      })
    },
    // 当前日期 yy-mm-ddd h
    getNowDate () {
      var date = new Date()
      var yy = date.getFullYear()
      var mm = date.getMonth() + 1
      var dd = date.getDate()
      if (mm >= 1 && mm <= 9) {
        mm = '0' + mm
      }
      this.beginDate = yy + '-' + mm + '-' + dd + ' ' + '00:00'
      this.endDate = yy + '-' + mm + '-' + dd + ' ' + '23:00'
      this.getHourlyRiverLevelData()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.getNowDate()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.leftMask{
  width: 370px;
  height: 220px;
  background: #7b8fad;
  float: left;
  position: absolute;
  top: 0;
  left: -228px;
  transform: skewX(23deg);
}
.nowWaterLevel{
  width: 250px;
  height: 30px;
  text-align: center;
  position: absolute;
  font-size: 16px;
  color: #666666;
  top: 0;
  left: 100px;
}
.waterLevelInfo{
  width: 500px;
  height: 70px;
  position: absolute;
  color: #dee5eb;
  left: 5px;
  bottom: 0;
}
.waterLevelInfo p{
  width: 100%;
  display: block;
  font-size: 12px;
}
#myChart{
  width: 510px;
  height: 220px;
}
</style>
